import React from 'react';
import SupplierInfoModal from './SupplierInfoModal';
import LeadmeKontakt from '../../../components/emails/LeadmeKontakt';
import LeverantorEpost from '../../../components/emails/LeverantorEpost';

/**
 * De tre modalerna bakom erbjudandena samlade, så att varje yta bara behöver
 * montera en komponent. Tar emot allt som `modalProps` från useErbjudanden.
 */
const ErbjudandeModaler = ({
  selectedSupplier,
  showInfoModal,
  showLeadmeContactModal,
  showSupplierEmailModal,
  contactResponsible,
  projects = [],
  activeProject = null,
  procurement = null,
  onContact,
  onRequestSaved,
  onCloseInfo,
  onCloseLeadme,
  onCloseSupplierEmail,
}) => {
  if (!selectedSupplier) return null;

  return (
    <>
      {showInfoModal && (
        <SupplierInfoModal
          isOpen={showInfoModal}
          onClose={onCloseInfo}
          supplier={selectedSupplier}
          onContact={onContact}
        />
      )}

      {showLeadmeContactModal && (
        <LeadmeKontakt
          isOpen={showLeadmeContactModal}
          onClose={onCloseLeadme}
          supplier={selectedSupplier}
          responsible={contactResponsible}
          projects={projects}
          activeProject={activeProject}
          procurement={procurement}
          onRequestSaved={onRequestSaved}
        />
      )}

      {showSupplierEmailModal && (
        <LeverantorEpost
          isOpen={showSupplierEmailModal}
          onClose={onCloseSupplierEmail}
          supplier={selectedSupplier}
          projectName={projects.length > 0 && projects[0].projectId ? `#${projects[0].projectId}` : ''}
          projectId={projects.length > 0 ? projects[0]._id : undefined}
          projects={projects}
        />
      )}
    </>
  );
};

export default ErbjudandeModaler;
